import { Button } from "@/components/ui/Button";
import classes from "./Form.module.scss";
import { useTranslation } from "@/hooks/useTranslation";
import { YourAddressWithConfig } from "@/components/YourAddress";
import { ImperativeHandle } from "@/types/Form";
import { useImperativeHandle, useRef } from "react";
import { dispatchEvent } from "@/utils/event-dispacher";
import { EventName } from "@/types/Events";
import { DetailsStep } from "@/types/Navigation";
import { useDonationFormStore } from "@/stores";

type FormStepYourAddressProps = {
  onStepSubmit: () => void;
  ref?: React.Ref<ImperativeHandle>;
};

export function FormStepYourAddress(props: FormStepYourAddressProps) {
  const { onStepSubmit, ref } = props;
  const t = useTranslation("_common");

  const yourAddressRef = useRef<ImperativeHandle>(null);
  const address = useDonationFormStore((state) => state.address);

  useImperativeHandle(ref, () => ({
    validate: async () => {
      if (!yourAddressRef.current) {
        return {
          isValid: true,
        };
      }

      return yourAddressRef.current.validate();
    },
  }));

  const handleSubmit = async () => {
    const validation = await yourAddressRef.current?.validate();
    if (validation?.isValid) {
      onStepSubmit();
      dispatchEvent(EventName.STEP_SUBMIT, {
        step_name: DetailsStep.YourAddress,
        data: address,
      });
    }
  };

  return (
    <div className={classes.grid}>
      <YourAddressWithConfig ref={yourAddressRef} />

      <div className={classes.pagination}>
        <Button variant="outlined" size="large" onClick={handleSubmit}>
          {t("continue")}
        </Button>
      </div>
    </div>
  );
}
